/* Core & libraries */
import React from "react";
import { models } from "powerbi-client";
import { PowerBIEmbed } from "powerbi-client-react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
/* Styles */
import styles from "./styles.js"

function PowerBi({ powerBiConfig }) {

  const theme = useTheme();
  const classes = styles({theme});

  return (
    <div className="App">
      <header className="App-header">
        {
        powerBiConfig &&
          <PowerBIEmbed
            embedConfig={{
              //hostname: "https://app.powerbigov.us/",
              type: "report", // Supported types: report, dashboard, tile, visual and qna
              id: powerBiConfig?.reportId,
              embedUrl: powerBiConfig?.embedConfig?.embedUrl,
              accessToken: powerBiConfig?.embedConfig?.embedToken,
              tokenType: models.TokenType.Embed,
              pageName: powerBiConfig?.pageName,
              settings: {
                panes: {
                  filters: {
                    expanded: false,
                    visible: false,
                  },
                  pageNavigation: {
                    visible: false,
                  },
                },
                background: models.BackgroundType.Transparent,
              },
            }}
            eventHandlers={
              new Map([
                [
                  "loaded",
                  function () {
                    console.log("Report loaded");
                  },
                ],
                [
                  "rendered",
                  function () {
                    console.log("Report rendered");
                  },
                ],
                [
                  "error",
                  function (event) {
                    console.log('ERR', event.detail);
                  },
                ],
              ])
            }
            cssClassName={classes.powerBi}
            // cssClassName={"report-style-class"}
          />
        }
      </header>
    </div>
  );
}
export default PowerBi;